exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-passanger[data-v-4426e0dc]{border:2px solid #334e61;display:flex;justify-content:space-between;cursor:pointer;color:rgba(0,34,71,.87);text-decoration:none;margin:35px 0 0}.title-passanger i[data-v-4426e0dc]{margin-top:4px}.needsChangeDate[data-v-4426e0dc]{padding-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4426e0dc","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/tabs/Flights.vue
// module id = 84
// module chunks = 0